import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultInput1Props = {
  error: boolean,
  title: string,
  value: string,
  setValue: (value: string) => void;
  place: string,
  length: number,
  desc?: string,
  hint?: any;
  setHintText?: (value: any) => void;
};

const DefaultInput1: React.FC<DefaultInput1Props> = ({ error, title, value, setValue, length, place, desc, hint, setHintText }) => {
  
  return (
    <>
    <DefaultTitle
      title={title}
      hint={hint}
      setHintText={setHintText}
      valueLength={value.toString().length}
      maxLength={length}
    />
    <textarea className={Styles.textarea} maxLength={length}
      placeholder={place} value={value} style={error ? { borderColor: "var(--mw-brand)", boxShadow: "0 0 0 3px var(--mw-focus)" } : undefined}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }} />
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultInput1;
